module.exports = __webpack_public_path__ + "static/media/obese.324c9090.png";